import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';
import { translateWithDefaults, TranslateFn } from '@app/shared/utils';
import { UserSearchItem } from '@app/user/user-api.model';
import {
  AvatarComponent,
  AvatarSize,
  IconComponent,
} from '@degreed/apollo-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-user-search-item-v3',
  standalone: true,
  imports: [AvatarComponent, IconComponent],
  templateUrl: './user-search-item-v3.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSearchItemV3Component {
  @Input() public item: UserSearchItem;
  @Input() public isActive = false;
  @Input() public isRemovable = false;
  @Input() public disableTabbing = false;

  public profileImageUrl = computed(() => this.item.picture);
  public isGroup = computed(() => this.item.hasOwnProperty('groupId'));
  public fallbackIcon = signal<string>(null);

  @Output() public onRemove = new EventEmitter<UserSearchItem>();
  public avatarSize = AvatarSize.Large;
  public translate: TranslateFn;

  constructor(private translateService: TranslateService) {
    this.translate = translateWithDefaults(translateService);
  }

  public ngOnInit(): void {
    if (this.isGroup()) {
      this.fallbackIcon.set('user-group');
    }
  }

  public onRemoveUser(): void {
    this.onRemove.emit(this.item);
  }
}
